import { BehaviorSubject } from 'rxjs';

export class LastConnection {
  public timestamp: string;
  public statusChanges = new BehaviorSubject<string>('initial');
  private _status = 'initial';
  public get status() {
    return this._status;
  }
  public set status(value: string) {
    this._status = value;
    this.statusChanges.next(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/LastConnection.ts